import React from "react";

export default function Banner(props) {
  return <div className="w-full  bg-[#051525] ">{props.mainBanner}</div>;
}
